
import { Component, Vue, Watch } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';

const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  collocation: `${FCAPI}/boss/ruan/collocation`,
  suit: `${FCAPI}/boss/ruan/suit`,
};
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
  },
})
export default class RuanPackageDetail extends Vue {
  is_loading = false;
  UPLOAD_DIR = UPLOAD_DIR;
  form_item_layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  form: any = {
    name: {
      number: 12,
    },
    price: {},
    tag_list: [],
    collocation: {},
    subcollocation: {
      data: undefined,
    },
    specific_image: '',
    area: {},
    specification: {},
    explan: '',
    list_image: {
      data: '',
    },
    index_image: {
      data: '',
    },
    detail_image: {
      data: [],
    },
  };
  tag_visible = false;
  tag_text = '';
  collocation_list = [];
  subcollocation_list = [];
  collocation_list_obj: any = {};
  subcollocation_list_obj: any = {};
  preview_image = '';
  preview_visible = false;
  send_data: any = {};

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  @Watch('form.list_image.data')
  onChangeListImg() {
    this.checkChange('list_image');
  }

  @Watch('form.index_image.data')
  onChangeIndexImg() {
    this.checkChange('index_image');
  }

  @Watch('form.detail_image.data')
  onChangeDetailImg() {
    this.checkChange('detail_image');
  }

  handleClose(item: string) {
    const tag_list = this.form.tag_list.filter((tag: any) => tag !== item);
    this.form.tag_list = tag_list;
  }

  onChangeTag(e: any) {
    this.tag_text = e.target.value;
  }

  addTag() {
    const tag_text = this.tag_text;
    if (tag_text && (this.form.tag_list as any).indexOf(tag_text) === -1) {
      (this.form.tag_list as any) = [...this.form.tag_list, tag_text];
    }
    Object.assign(this, {
      tag_visible: false,
      tag_text: '',
    });
  }

  showAddTagInput() {
    this.tag_visible = true;
    this.$nextTick(() => {
      (this.$refs.input as any).focus();
    });
  }

  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }

  handlePreviewCancel() {
    this.preview_visible = false;
  }

  beforePackageImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 670 && height === 160
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 670*160px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  beforeListImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 670 && height === 313
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 670*313px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  beforeIndexImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 750 && height === 750
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 750*750px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  onSelectCollocation(value: any) {
    this.form.subcollocation.data = undefined;
    const subcollocation = this.collocation_list.filter((item: any) => {
      return item.id === value;
    });
    this.subcollocation_list = subcollocation[0]
      ? (subcollocation[0] as any).sub
      : [];
    this.subcollocation_list.forEach((item: any) => {
      this.subcollocation_list_obj[item.id] = item.name;
    });
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入套餐名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      if (this.form.name.data) {
        this.form.name.number =
          this.form.name.data.length > 12 ? 0 : 12 - this.form.name.data.length;
        if (this.form.name.data.length > 12) {
          this.form.name.status = 'error';
          this.form.name.error = '套餐名称最多12个字';
          error = '1';
        } else {
          this.form.name.status = '';
          this.form.name.error = '';
        }
      } else {
        this.form.name.number = 12;
      }
      return error;
    } else if (field === 'price') {
      if (!this.form.price.data) {
        this.form.price.status = 'error';
        this.form.price.error = '请输入套餐价格';
        error = '1';
      } else {
        this.form.price.status = '';
        this.form.price.error = '';
      }
      return error;
    } else if (field === 'collocation') {
      if (!this.form.collocation.data) {
        this.form.collocation.status = 'error';
        this.form.collocation.error = '请选择搭配';
        error = '1';
      } else {
        this.form.collocation.status = '';
        this.form.collocation.error = '';
      }
      return error;
    } else if (field === 'subcollocation') {
      if (!this.form.subcollocation.data) {
        this.form.subcollocation.status = 'error';
        this.form.subcollocation.error = '请选择子搭配';
        error = '1';
      } else {
        this.form.subcollocation.status = '';
        this.form.subcollocation.error = '';
      }
      return error;
    } else if (field === 'area') {
      if (!this.form.area.data) {
        this.form.area.status = 'error';
        this.form.area.error = '请输入参考面积范围';
        error = '1';
      } else {
        this.form.area.status = '';
        this.form.area.error = '';
      }
      return error;
    } else if (field === 'specification') {
      if (!this.form.specification.data) {
        this.form.specification.status = 'error';
        this.form.specification.error = '请输入套餐的配置内容';
        error = '1';
      } else {
        this.form.specification.status = '';
        this.form.specification.error = '';
      }
      return error;
    } else if (field === 'list_image') {
      if (!this.form.list_image.data) {
        this.form.list_image.status = 'error';
        this.form.list_image.error = '请上传列表图';
        error = '1';
      } else {
        this.form.list_image.status = '';
        this.form.list_image.error = '';
      }
      return error;
    } else if (field === 'index_image') {
      if (!this.form.index_image.data) {
        this.form.index_image.status = 'error';
        this.form.index_image.error = '请上传首图';
        error = '1';
      } else {
        this.form.index_image.status = '';
        this.form.index_image.error = '';
      }
      return error;
    } else if (field === 'detail_image') {
      if (this.form.detail_image.data.length <= 0) {
        this.form.detail_image.status = 'error';
        this.form.detail_image.error = '请上传详情图';
        error = '1';
      } else {
        this.form.detail_image.status = '';
        this.form.detail_image.error = '';
      }
      return error;
    }
    return error;
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  sendData() {
    const form = this.form;
    const send_data: any = {
      name: form.name.data,
      price: form.price.data * 100,
      tag: form.tag_list.length > 0 ? form.tag_list.join(',') : '',
      collocation_id: form.collocation.data,
      collocation_name: this.collocation_list_obj[form.collocation.data],
      collocation_sub_id: form.subcollocation.data,
      collocation_sub_name: this.subcollocation_list_obj[
        form.subcollocation.data
      ],
      specific_image: form.specific_image,
      area: form.area.data,
      specification: form.specification.data,
      description: form.explan,
      list_image: form.list_image.data,
      index_image: form.index_image.data,
      detail_image: form.detail_image.data,
    };
    if (!this.isNew) {
      send_data.id = this.id;
    }
    this.send_data = send_data;
  }

  async submit() {
    if (!this.validator()) {
      return;
    }
    if (this.isNew) {
      this.add();
    } else {
      this.edit();
    }
  }

  async add() {
    this.sendData();
    const res = await this.$axios.post(API.suit, this.send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('新增成功');
    this.$router.push({
      path: '/ruan/package-list',
    });
  }

  async edit() {
    this.sendData();
    const res = await this.$axios.put(`${API.suit}/${this.id}`, this.send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
    this.$router.push({
      path: '/ruan/package-list',
    });
  }

  async getCollocation() {
    const res = await this.$axios.get(API.collocation);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.collocation_list = data;
    this.collocation_list.forEach((item: any) => {
      this.collocation_list_obj[item.id] = item.name;
    });
  }

  async query() {
    const res = await this.$axios.get(`${API.suit}/${this.id}?id=${this.id}`);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    const form = this.form;
    form.name.data = data.name;
    form.price.data = data.price / 100;
    form.tag_list = data.tag.split(',');
    form.collocation.data = data.collocation_id;
    this.onSelectCollocation(form.collocation.data);
    form.subcollocation.data = data.collocation_sub_id;
    this.send_data.collocation_name = this.collocation_list_obj[
      form.collocation.data
    ];
    this.send_data.collocation_sub_name = this.subcollocation_list_obj[
      form.subcollocation.data
    ];
    form.specific_image = data.specific_image;
    form.area.data = data.area;
    form.specification.data = data.specification;
    form.explan = data.description;
    form.list_image.data = data.list_image;
    form.index_image.data = data.index_image;
    form.detail_image.data = data.detail_image;
  }

  async created() {
    await this.getCollocation();
    if (!this.isNew) {
      await this.query();
    }
  }
}
